import { getUser } from "../actions/auth";

const HOUSEHOLD_CUSTOM_ID_EDIT_ACTIONS = ["edit custom id"];
// "edit custom id" implies the ability to view it.
const HOUSEHOLD_CUSTOM_ID_VIEW_ACTIONS = ["view custom id", ...HOUSEHOLD_CUSTOM_ID_EDIT_ACTIONS];
export const HOUSEHOLD_PAGE_ACTIONS = ["show", "edit", ...HOUSEHOLD_CUSTOM_ID_VIEW_ACTIONS];
const ADVISOR_ROLE_NAMES = ["Advisor", "Advisor with HH ID", "With STRIPS"];
const ADMINISTRATOR_ROLE_NAME = "AD Administrator";

function getPermissions(user = getUser()) {
  return user?.Role?.permissions || {};
}

export function hasPermission(authorize, action, user = getUser()) {
  const permissions = getPermissions(user);
  if (permissions["*"] === true) {
    return true;
  }
  const actions = Array.isArray(action) ? action : [action];

  return actions.some((permissionAction) => {
    return permissions[authorize]?.[permissionAction] === true;
  });
}

export function canAccessServiceTeam(serviceTeamId, user = getUser()) {
  if (!user || !serviceTeamId) {
    return false;
  }

  const serviceTeamPermissions = user.Role?.permissions?.["service teams"];
  const hasGlobalAccess =
    user.all_advisors === true ||
    user.Role?.name === "AD Administrator" ||
    serviceTeamPermissions === true ||
    hasPermission("service teams", ["new", "edit", "activate"], user);
  if (hasGlobalAccess) {
    return true;
  }

  return (user.ServiceTeams || []).some((team) => team.service_team === serviceTeamId);
}

export function canEditHousehold(user = getUser()) {
  return hasPermission("households", "edit", user);
}

export function canViewHouseholdCustomId(user = getUser()) {
  return hasPermission("households", HOUSEHOLD_CUSTOM_ID_VIEW_ACTIONS, user);
}

export function canEditHouseholdCustomId(user = getUser()) {
  return hasPermission("households", HOUSEHOLD_CUSTOM_ID_EDIT_ACTIONS, user);
}

export function canPurchaseStrips(user = getUser()) {
  const permissions = getPermissions(user);
  if (permissions["trading requests"] === true) {
    return true;
  }
  return hasPermission("trading requests", "purchase strips", user);
}

export function isAdministrator(user = getUser()) {
  return user?.Role?.name === ADMINISTRATOR_ROLE_NAME || user?.Role?.permissions?.["*"] === true;
}

// The Custom Household ID is hidden from everyone unless the user's role explicitly
// grants view (or edit) access. This keeps the field invisible by default.
export function showHouseholdCustomId(user = getUser()) {
  return canViewHouseholdCustomId(user);
}

export function isAdvisorRole(roleName) {
  return ADVISOR_ROLE_NAMES.includes(roleName);
}
